/**
 * useSuspendAppEvents
 *
 * Opt-in, ref-counted suspend of app-window command listeners. Wire this at
 * overlay shells that sit above every Space window (`ModalWrapper`,
 * `FloatingSystemWindow`, and custom `document.body` system portals) — not
 * on app-owned dropdowns, header menus, or toasts.
 */

import { useEffect } from 'react';
import { suspendAppEvents } from '../services/appWindowEventGate';

export function useSuspendAppEvents(reason: string, open: boolean = true): void {
  useEffect(() => {
    if (!open) return;
    return suspendAppEvents(reason);
  }, [open, reason]);
}
